<template>
  <div style="position: absolute; left: 0; top:0; right: 0; bottom: 0; width: 100%; height: 100%;">
    <data-card v-for="card in $store.state.cards.cards" :key="card.key" :data="card">
      <template v-slot:title>
        {{card.title}}
      </template>
      <template v-slot:default>
        <component :is="typeComponentMap[card.type]" :item="card"></component>
      </template>
      <template v-if="card.affiliateLink" v-slot:share-link>
        <v-btn icon color="white" title="Share" @click="copyLink(card.affiliateLink)"><v-icon>mdi-share</v-icon></v-btn>
      </template>
    </data-card>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import DataCard from "@/components/common/DataCard";
import OfferCard from "@/components/pages/advertisers/offers/OfferCard";
import LidCard from "@/components/pages/advertisers/offers/LidCard.vue";
import ProgramCard from "@/components/pages/advertisers/programs/ProgramCard";
import AdvertiserCard from "@/components/pages/advertisers/profile/AdvertiserCard";
import AffiliateCard from "@/components/pages/affiliates/profiles/AffiliateCard";
import CampaignCard from "@/components/pages/affiliates/campaigns/CampaignCard";
import OfferAggregatedLPCard from "@/components/pages/advertisers/offers/OfferAggregatedLPCard.vue";
import ChatCard from "@/components/pages/chat/ChatCard.vue";
import ChatMessagesCard from "@/components/pages/chat/ChatMessagesCard.vue";
import store from "../../../store";

export default {
  name: "DataCardList",
  data() {
    return {
      typeComponentMap: {
        'offer': OfferCard,
        'lid': LidCard,
        'program': ProgramCard,
        'advertiser': AdvertiserCard,
        'affiliate': AffiliateCard,
        'campaign': CampaignCard,
        'offerAggregatedLPCard': OfferAggregatedLPCard,
        'chat': ChatCard,
        'chatMessages': ChatMessagesCard
      }
    }
  },
  computed : {
    ...mapGetters('cards', ['maximizedCards'])
  },
  components: {
    DataCard,
    LidCard,
    OfferCard,
    ProgramCard,
    AdvertiserCard,
    AffiliateCard,
    CampaignCard,
    OfferAggregatedLPCard,
    ChatCard
  },
  methods: {
    async copyLink(url) {
      this.$store.dispatch('alert/ALERT_SUCCESS', 'Link Copied');

      await navigator.clipboard.writeText(url)
      setTimeout(()=>{
        this.$store.dispatch('alert/ALERT_SUCCESS', '');
      },3500)
    }
  }
}
</script>

<style scoped>

</style>
